import AbsSection from '../common/AbsSection';
import MoviePlayer from '../common/MoviePlayer';
import { Draggable, TweenMax } from 'gsap/all';

import { getReencodedUriParams, getUriCombinedParams, setCookie } from '../common/util';

class SecPassage extends AbsSection {

    constructor(_store = {}, _el = '') {
        super('passage', _store, _el);
    }

    setting() {
        this.videoList = {
            mobile: {
                loop: {
                    url: this.moviepath + '/new/MO_lobby_low.mp4',
                    width: 2152*0.7, height: 1000*0.7
                }
            },
            tablet: {
                loop: {
                    url: this.moviepath + '/new/MO_lobby_low.mp4',
                    width: 2152, height: 1000
                }
            },
            pc: {
                loop: {
                    url: this.moviepath + '/new/PC_lobby_low.mp4',
                    width: 2754, height: 1280
                }
            }
        }[this.store.getState().config.device];

        this.vidLoop = new MoviePlayer({
            url: this.videoList.loop.url,
            parentNode: $(this.el + ' .vid .draggable'),
            movieW: this.videoList.loop.width, movieH: this.videoList.loop.height,
            selector: 'secPassageloop', videoControl: 'preload="auto" playsinline muted="muted" loop',
            isBgType: false,
            stateCallback: (state) => { }
        });

        this.vidLoop.node.width(this.videoList.loop.width);

        this.drag = Draggable.create(this.el + " .drag-wrap", { type: "scroll", edgeResistance: 1, throwProps: true })[0];

        this.reset();
    }

    addEvents() {
        $(this.el + ' [data-stamp]').on('click', e => {
            const stampData = parseInt(e.currentTarget.dataset.stamp);
            if (stampData) {
                this.store.dispatch(this.actions.addStamp(stampData));
            }
        });

        $(this.el + ' .spot-list .go-preorder').on('click', e => {
            const params = getReencodedUriParams(location.href) || {};
            const url = getUriCombinedParams('/preorder/record/200624/index' || '', params);
            window.open(url, '_blank');
        });

        $(this.el + ' .spot-list button.btn-next').on('click', e => {
            this.store.dispatch(this.actions.setNowpage(e.currentTarget.dataset.name));
        });


        if (this.store.getState().config.device === 'mobile') {
            $(this.el + ' .spot-list button.btn-spot').on('click', e => {
                $(this.el + ' .spot-list button.btn-spot-layer').hide();
                $(e.currentTarget).siblings('.btn-spot-layer').show();
            });
        }
    }

    setAniObj() {
        super.setAniObj();
        TweenMax.set(this.el + ' .title', { autoAlpha: 0, scale: 1.3 });
        TweenMax.set(this.vidLoop.node, { autoAlpha: 0, scale: 1.3 });
        TweenMax.set(this.el + ' .btn-spot', { scale: 0 });
    }

    titleAni() {
        $(this.el + ' .title').show();
        TweenMax.to(this.el + ' .title', 3.5, { autoAlpha: 1, scale: 1 });
        TweenMax.to(this.vidLoop.node, 1.7, { autoAlpha: 1, scale: 1, ease: Quint.easeOut });
        TweenMax.staggerTo(this.el + ' .btn-spot', 0.5, { scale: 1, ease: Quint.easeOut }, 0.2);

        TweenMax.fromTo(this.el + ' .noti-drag', 0.8, 
            { autoAlpha: 1, display: 'block' }, 
            { autoAlpha: 0, display: 'none', delay: 1.5 }
        );
    }

    start() {
        super.start();
        this.store.dispatch(this.actions.addSecCookies(this.name));
        this.vidioReset(this.vidLoop, 2, true).play(0);
    }

    end() {
        // super.end();
        TweenMax.to(this.el + ' .btn-spot', 0.3, { scale: 0, ease: Quint.easeIn });

        let tOrigin = 'center';
        let scrLeft = Math.abs(Math.round((this.$win.width() - this.videoList.loop.width) / 2));
        let scrTop = -Math.round((this.$win.height() - this.videoList.loop.height) / 2);
        if (this.nextSecName === 'garden') {
            scrLeft = Math.abs(Math.round((this.$win.width() - this.videoList.loop.width)));
            tOrigin = 'right';
        }
        TweenMax.to(this.drag.scrollProxy, 0.6, { scrollLeft: scrLeft, scrollTop: (scrTop < 0 ? 0 : scrTop), ease: Quint.easeOut });

        this.vidioReset(this.vidLoop, 1, true).pause();

        TweenMax.to(this.vidLoop.node, 1.3, {
            autoAlpha: 0, scale: 1.3, ease: Expo.easeIn, transformOrigin: tOrigin, onComplete: () => {
                this.transitionEnd();
            }
        });
    }

    reset() {
        super.reset();
        this.vidioReset(this.vidLoop).pause();
    }

} // end of class
export default SecPassage;